import React from 'react'

import SnackContent from './snack'

class ZariSnackBar extends React.PureComponent {
  state = {
    open: false,
    tipo: '',
    mensaje: ''
  }

  setSnackOpen = () => {
    this.setState({
      open: !this.state.open
    })
  }

  snack = ({ tipo, mensaje }) => {
    this.setState({
      open: true,
      tipo,
      mensaje
    })
  }

  render = () => {
    if (this.state.open) {
      return (
        <SnackContent
          open={this.state.open}
          setOpen={this.setSnackOpen}
          tipo={this.state.tipo}
          mensaje={this.state.mensaje}
        />
      )
    } else {
      return null
    }
  }
}

export default ZariSnackBar
